module.exports = __webpack_public_path__ + "img/阵雨夹雪.990cea6f.png";